export default function ControlesConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('controles');
}

ControlesConfiguration.$inject = ['$translatePartialLoaderProvider'];
